<template>
    <div class="page">
        <z-device-type ref="deviceType" @refresh="refresh()"></z-device-type>
        <div id='components-form-demo-advanced-search'>
            <div class="content" style="padding: 15px">
                <div>
                    <a-row type="flex" justify="start" :gutter="8" style="margin-bottom:5px">
                        <a-col>
                            <a-button size="small" @click="showAddDeviceType" type="primary">
                                <a-icon type="plus"/>
                                新增
                            </a-button>
                        </a-col>
                    </a-row>
                </div>

                <div class='section-list'>
                    <a-spin :spinning="isLoading" tip="加载中...">
                        <a-table :columns="columns" :dataSource="data" :pagination="pagination">
                            <template slot="enabled" slot-scope="text">
                                <a-badge status="success" text="是" v-if="text == '1'"/>
                                <a-badge status="error" text="否" v-if="text == '0'"/>
                            </template>
                            <template slot="image" slot-scope="text">
                              <PreViewImage :src="text"  class="table-img" />
                            </template>
                            <template slot="operate" slot-scope="text,record">
                                <a href="javascript:;" @click="showEditDeviceType(record)">编辑</a>
                                <a-divider type="vertical" />
                                <a-popconfirm title="确认删除吗?" @confirm="deleteDeviceType(record.id)">
                                    <a href="javascript:;">删除</a>
                                </a-popconfirm>
                            </template>
                        </a-table>
                    </a-spin>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from '@/config'
    import ZDeviceType from '@/views/device/DeviceType.vue'
    import PreViewImage from '../../components/common/PreViewImage'
    export default {
        data() {
            return {
                isLoading: false,
                pagination:{pageSize: 10},
                data: [],
                columns: [{
                    "title": "型号名称",
                    "dataIndex": "name",
                    "key": "name",
                    "left": true
                },{
                    "title": "设备图片",
                    "dataIndex": "image",
                    "key": "image",
                    "scopedSlots": {
                        "customRender": "image"
                    }
                },{
                    "title": "支持有线",
                    "dataIndex": "wired",
                    "key": "wired",
                    "scopedSlots": {
                        "customRender": "enabled"
                    }
                },{
                    "title": "支持GPS",
                    "dataIndex": "capbilityGps",
                    "key": "capbilityGps",
                    "scopedSlots": {
                        "customRender": "enabled"
                    }
                },{
                    "title": "支持LBS",
                    "dataIndex": "capbilityLbs",
                    "key": "capbilityLbs",
                    "scopedSlots": {
                        "customRender": "enabled"
                    }
                },{
                    "title": "支持WIFI",
                    "dataIndex": "capbilityWifi",
                    "key": "capbilityWifi",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持蓝牙",
                    "dataIndex": "capbilityBluetooth",
                    "key": "capbilityBluetooth",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持计步",
                    "dataIndex": "capbilityStep",
                    "key": "capbilityStep",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持电子锁",
                    "dataIndex": "capbilityElock",
                    "key": "capbilityElock",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持开锁检测",
                    "dataIndex": "capbilityLockDetect",
                    "key": "capbilityLockDetect",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持心率",
                    "dataIndex": "capbilityHeartrate",
                    "key": "capbilityHeartrate",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持血压",
                    "dataIndex": "capbilityBloodPressure",
                    "key": "capbilityBloodPressure",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持血氧",
                    "dataIndex": "capbilityBloodOxygen",
                    "key": "capbilityBloodOxygen",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },{
                    "title": "支持温度",
                    "dataIndex": "capbilityTemperature",
                    "key": "capbilityTemperature",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },
                {
                    "title": "支持充值",
                    "dataIndex": "rechargeable",
                    "key": "rechargeable",
                    "scopedSlots": {
                        "customRender": "enabled"
                    },
                },
                {
                    "title": "设备制式",
                    "dataIndex": "correspondStandard",
                    "key": "correspondStandard",
                    // "scopedSlots": {
                    //     "customRender": "enabled"
                    // },
                },{
                    "title": '操作',
                    "key": 'action',
                    "scopedSlots": {
                        "customRender": "operate"
                    }
                }]
            }
        },
        components:{
            ZDeviceType,
            PreViewImage
        },
        methods:{
            refresh() {
                this.queryTypes()
            },
            showEditDeviceType(record){
                this.$refs["deviceType"].showModel(record)
            },
            deleteDeviceType(id){
                this.$http.delete(config.api.device_types_url + "/" + id).then((response) => {
                    if(response.code == 0){
                        this.queryTypes()
                    } else {
                      this.$notification.error({
                        message: response.desc
                      })
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            showAddDeviceType(){
                this.$refs["deviceType"].showModel(null)
            },
            queryTypes(){
                this.isLoading = true
                this.$http.get(config.api.device_types_url).then((response) => {
                  // console.log(response)
                    if(response.code == 0){
                        this.data = []
                        response.result.map(item => {
                            let model = {}
                            model.name = item.name
                            model.id = item.id
                            model.wired = item.wired ? "1" : "0"
                            model.capbilityGps = item.capbilityGps ? "1" : "0"
                            model.capbilityLbs = item.capbilityLbs ? "1" : "0"
                            model.capbilityWifi = item.capbilityWifi ? "1" : "0"
                            model.capbilityBluetooth = item.capbilityBluetooth ? "1" : "0"
                            model.capbilityStep = item.capbilityStep ? "1" : "0"
                            model.capbilityElock = item.capbilityElock ? "1" : "0"
                            model.capbilityLockDetect = item.capbilityLockDetect ? "1" : "0"
                            model.capbilityHeartrate = item.capbilityHeartrate ? "1" : "0"
                            model.capbilityBloodPressure = item.capbilityBloodPressure ? "1" : "0"
                            model.capbilityBloodOxygen = item.capbilityBloodOxygen ? "1" : "0"
                            model.capbilityTemperature = item.capbilityTemperature ? "1" : "0"
                            model.rechargeable = item.rechargeable ? "1" : "0"
                            model.image = item.image
                            model.correspondStandard = item.correspondStandard || ''
                            this.data.push(model)
                        })
                        // console.log(this.data)
                    }
                    this.isLoading = false
                }).catch((err) => {
                    console.log(err)
                    this.isLoading = false
                })
            }
        },
        created() {
            this.queryTypes()
        }
    }
</script>
<style lang="less" scoped>
 .table-img {
   cursor: pointer;
   max-height: 17px;
 }
</style>
